export const AdminRole = 1;
export const Clientrole = 2;
